export const yearsOfTeaching = Array(100)
  .fill(0)
  .map((_, i) => ({ value: `${i + 1}`, label: `${i + 1}年` }));
